import { EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { of, timer } from 'rxjs';
import * as moment from 'moment';
import { ApiService } from '../../../../../services/api.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import Decimal from 'decimal.js-light';
import { TranslateService } from '@ngx-translate/core';
var DocumentIssueFormComponent = (function () {
    function DocumentIssueFormComponent(formBuilder, apiService, translateService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.translateService = translateService;
        this.data = new EventEmitter();
        this.username = localStorage.getItem('username');
        this.documentNoValidator = function (control) {
            var sellerForm = control.get('sellerForm');
            var documentForm = control.get('documentForm');
            var sellerTaxID = sellerForm.value ? sellerForm.value['taxID'] : null;
            var documentNo = documentForm.value ? documentForm.value['documentNo'] : null;
            var params = {
                seller_tax_id: sellerTaxID,
                document_no: documentNo
            };
            return timer(300).pipe(switchMap(function () {
                return _this.apiService.checkMatchedInvoiceNumber(params).pipe(map(function (res) { return (res.duplicate ? { duplicateDocumentNo: { value: 'Duplicate Document Number' } } : null); }), catchError(function () { return of(null); }));
            }));
        };
    }
    DocumentIssueFormComponent.prototype.ngOnInit = function () {
        this.createDocumentIssueForm();
    };
    Object.defineProperty(DocumentIssueFormComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    DocumentIssueFormComponent.prototype.submit = function () {
        if (this.documentIssueForm.valid) {
            var documentIssue = this.documentIssueForm.value;
            var seller = documentIssue.sellerForm;
            var document_1 = documentIssue.documentForm;
            var buyer = documentIssue.buyerForm;
            var lineItem = documentIssue.lineItemForm;
            if (lineItem.correctAmount.includes('-')) {
                return;
            }
            var data = {
                file_type: this.document.type || '',
                document_number: document_1.runningNo || '',
                branch_code: seller.branchCode || '',
                branch_name: seller.branchName || '',
                invoice_number: document_1.documentNo || '',
                issue_dt: moment(document_1.documentDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss'),
                purpose: document_1.purpose || '',
                abb_no: document_1.abbNo || '',
                confirmation_no: document_1.confirmationNo || '',
                document_request_id: document_1.documentRequest,
                order_no: document_1.orderNo || '',
                reference: document_1.referenceDocuments.map(function (referenceDocument) {
                    return ({
                        ref_date: referenceDocument.documentDate ? moment(referenceDocument.documentDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss') : '',
                        ref_doc_no: referenceDocument.documentNo || '',
                        ref_doc_type: referenceDocument.documentType || ''
                    });
                }),
                seller: {
                    name_th: seller.name || '',
                    name_en: seller.nameEN || '',
                    tax_id: seller.taxID || '',
                    address_th: seller.address || '',
                    address_en: seller.addressEN || '',
                    post_code: seller.postalCode || '',
                },
                buyer: {
                    name: buyer.name || '',
                    tax_id: buyer.taxID || '',
                    branch_code: buyer.branchCode || '',
                    branch_name: buyer.branchName || '',
                    address: buyer.address || '',
                    post_code: buyer.postalCode || '',
                    country_code: buyer.country || '',
                    email: buyer.email || '',
                    cc_email: buyer.ccEmail || ''
                },
                line_items: lineItem.items.map(function (item, index) { return ({
                    item_number: String(index + 1),
                    product_id: item.productID || '',
                    product_name: item.description || '',
                    quantity: item.quantity || '0',
                    unit: item.unit || '',
                    unit_price: item.unitPrice || '0',
                    net_discount_or_charge: item.discount || '0',
                    net_total_amount: item.total,
                    line_vat: item.lineVAT || '0'
                }); }),
                total_items: {
                    line_total_amount: (new Decimal(lineItem.subTotal).minus(new Decimal(lineItem.discountTotal))).toFixed(2),
                    line_total_amount_after_discount: lineItem.balance,
                    vat: lineItem.vat,
                    non_vat_amount: lineItem.nonVATAmount,
                    vat_0_amount: lineItem.vat0Amount,
                    vat_amount: lineItem.vatAmount,
                    total_payment: lineItem.netTotal,
                    discount_or_charge: lineItem.endOfBillDiscount || '0',
                    discount_or_charge_reason: lineItem.discountReason || '',
                    original_amount_before_vat: lineItem.originalAmount || '',
                    original_amount_vat: lineItem.originalVAT || '',
                    correct_amount: lineItem.correctAmount || '',
                    difference_amount: ['credit_note', 'debit_note'].includes(this.document.type) ? lineItem.balance : '0',
                }
            };
            this.data.emit(data);
        }
    };
    DocumentIssueFormComponent.prototype.createDocumentIssueForm = function () {
        this.documentIssueForm = this.formBuilder.group({
            sellerForm: [],
            documentForm: [],
            buyerForm: [],
            lineItemForm: []
        }, { asyncValidator: this.documentNoValidator });
    };
    DocumentIssueFormComponent.prototype.onDocumentRequestSelected = function (event) {
        var buyerForm = this.documentIssueForm.get('buyerForm');
        buyerForm.patchValue({
            name: event ? event.buyer_name : null,
            taxID: event ? event.tax_id : null,
            branchCode: event ? event.branch_code : null,
            branchName: event ? event.branch_code : null,
            address: event ? event.address : null,
            postalCode: event ? event.postal_code : null,
            country: event ? event.country_code : null,
            email: event ? event.email : null,
            ccEmail: event ? event.cc_email : null,
        });
    };
    return DocumentIssueFormComponent;
}());
export { DocumentIssueFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-issue-form/document-issue-form.component.ts.pre-build-optimizer.js